module.exports = __webpack_public_path__ + "assets/img/Dempsey Hill.6c01fc72.jpg";